import {ASSIGNMENT_STATUS} from "Services/assignment/constants";
import {activityStatus} from "Constants/constants";
import studentRecordService from "../../StudentRecordService";
import { logSessionInfo } from "../../logger";

export default async function getPendingManifest(manifest){
  let activitiesToUnassign = [];
  let filteredManifest = manifest.filter((item) => {
    const {status, activity} = item;
    const assignedActivities = activity.filter(a => a.status === activityStatus.ASSIGNED);
    const completedActivities = activity.filter(a => ["scored","rescored","underReview"].includes(a.status) || a.displayStatus === activityStatus.COMPLETED);
    const validActivities = activity.filter(a => !(["downleveled","unassigned"].includes(a.displayStatus) || ["archived"].includes(a.status)));

    if(assignedActivities.length > 1 || completedActivities.length > 0){
      assignedActivities.map((act,index)=>{
        if(act.status === activityStatus.ASSIGNED && (index>0 || completedActivities.length > 0)){
            activitiesToUnassign.push(act);
            console.log("UNASSIGNING",act);
          }
      });
    }
    let anyAssigned = (assignedActivities.length > 0 && completedActivities.length === 0) ||
                      ([ASSIGNMENT_STATUS.ASSIGNED,ASSIGNMENT_STATUS.IN_PROGRESS].includes(status) && validActivities.length === 0);
    return anyAssigned && status !== ASSIGNMENT_STATUS.DONE;
  });

  await Promise.all(activitiesToUnassign.map(async (act)=>{
    await studentRecordService.markCompleted(act.activityId,"unassigned");
  }));

  return filteredManifest;
}
